import { motion, AnimatePresence } from 'framer-motion'
import { CaretLeft } from 'phosphor-react'
import { type ReactNode } from 'react'
import { createPortal } from 'react-dom'

type MobileScreenProps = {
  title: string
  isVisible: boolean
  children: ReactNode | ReactNode[]
  onGoBack: () => void
}

export const MobileScreen = ({
  title,
  isVisible,
  children,
  onGoBack,
}: MobileScreenProps) => {
  return createPortal(
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed top-0 bottom-0 left-0 right-0 z-50 flex flex-col w-screen overflow-y-auto bg-white"
        >
          <header className="min-h-[80px] shadow-[0_4px_10px_rgba(0,0,0,0.08)] flex items-center px-6">
            <button type="button" onClick={onGoBack}>
              <CaretLeft
                className="justify-self-start text-grey-700"
                size={32}
              />
            </button>

            <h1 className="font-semibold text-center grow text-grey-900">
              {title}
            </h1>
          </header>

          <div className="flex flex-col grow">{children}</div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  )
}
